import { render, staticRenderFns } from "./AddNewImage.vue?vue&type=template&id=f52417b2&scoped=true&"
import script from "./AddNewImage.vue?vue&type=script&lang=js&"
export * from "./AddNewImage.vue?vue&type=script&lang=js&"
import style0 from "./AddNewImage.vue?vue&type=style&index=0&id=f52417b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52417b2",
  null
  
)

export default component.exports